import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../common_widgets/popup";
import MdaeDataGrid, { IMdaeDataGridProps } from "../common_widgets/data-grid";
import MdaeButton from "../common_widgets/button";
import "./index.scss";
import DataGrid, { Column, MasterDetail } from "devextreme-react/data-grid";
import $ from "jquery";
import { USER_TYPE } from "../user-task-list/constant";
import {
  SET_CURRENT_SELECTED_GROUP_ROW_DATA,
  SET_SELECT_GROUP_DATAGRID_INSTANCE,
  SET_USER_TASK_BULK_EDIT_DATA,
  SET_USER_TASK_FORM_DATA,
  TOGGLE_SELECT_ASSIGNED_GROUP_USER_POPUP,
} from "../user-task-list/reducers/user-task-list-reducer";
import { cloneDeep, first } from "lodash";
import {
  FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
  SET_TASK_FORM_DATA,
} from "../../pages/external-audit-setup/process-template/reducer/process-template-reducer";
import { SET_TASK_TEMPLATE_FORM_DATA } from "../../pages/task-template/reducers/task-template-reducer";

export const toggleSelectAssignedGroupUserPopup = (dispatch, isVisible) => {
  dispatch({
    type: TOGGLE_SELECT_ASSIGNED_GROUP_USER_POPUP,
    data: {
      isSelectAssignedGroupUserPopupVisible: isVisible,
    },
  });
};

interface ISelectAssignedGroupUserProps {
  getAssignedUserList?: (
    auditGroupId: number,
    isFromAssignedToField: boolean
  ) => any[];
  auditGroupId?: number;
  isPopupOpenedFromTaskTemplate?: boolean;
  isPopupOpenedFromBulkEdit?: boolean;
  selectedRowsDataForBulkEdit?: any[];
  isPopupOpenedFromProcessTemplateTaskTrigger?: boolean;
  getAssignToList?: (selectedRowsDataForBulkEdit: any[]) => any[];
}
interface ISelectUserGroupProps {}

const SelectAssignedGroupUser: React.FC<ISelectAssignedGroupUserProps> = (
  props
) => {
  const dispatch = useDispatch();
  const isSelectAssignedGroupUserPopupVisible = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectAssignedGroupUserPopupVisible
  );
  const assignedUserType = useSelector(
    (state: any) => state.userTaskListReducer.assignedUserType
  );
  const selectGroupDataGridInstance = useSelector(
    (state: any) => state.userTaskListReducer.selectGroupDataGridInstance
  );
  const setCurrentSelectedGroupRowData = useSelector(
    (state: any) => state.userTaskListReducer.setCurrentSelectedGroupRowData
  );
  const isSelectUserPopupOpenedFromCompletedByBulkEdit = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectUserPopupOpenedFromCompletedByBulkEdit
  );
  const isSelectUserPopupOpenedFromCompletedBy = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectUserPopupOpenedFromCompletedBy
  );
  const taskFormData = useSelector(
    (state: any) => state.processTemplateReducer.taskFormData
  );
  const assignedToUserTypeList = useSelector(
    (state: any) => state.taskTemplateReducer.assignedToUserTypeList
  );
  const taskGroupList = useSelector(
    (state: any) => state.taskGroupReducer.taskGroupList
  );
  const externalUserGroupList = useSelector(
    (state: any) => state.externalUsersReducer.externalUserGroupList
  );
  const getSelectExternalUserGroupPopupTitle = useCallback(() => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleSelectAssignedGroupUserPopup(dispatch, false);
        }}
      >
        {assignedUserType == USER_TYPE.EG
          ? "Select External User Group"
          : "Select Task Group"}
      </MdaePopupTitle>
    );
  }, [assignedUserType]);
  const selectUserToUserGroup = useCallback(() => {
    var selectedRowsData = selectGroupDataGridInstance?.getSelectedRowsData();
    if (selectedRowsData && selectedRowsData.length > 0) {
      const selectedUserGroup: any = cloneDeep(first(selectedRowsData));
      if (props.isPopupOpenedFromBulkEdit) {
        if (!isSelectUserPopupOpenedFromCompletedByBulkEdit) {
          dispatch({
            type: SET_USER_TASK_BULK_EDIT_DATA,
            data: {
              userTaskBulkEditData: {
                assignedToUserId:
                  assignedUserType == USER_TYPE.TG
                    ? selectedUserGroup.taskGroupId
                    : selectedUserGroup.externalUserGroupId,
                assignedUserType: assignedUserType,
              },
            },
          });
        }
        if (props.selectedRowsDataForBulkEdit)
          props.getAssignToList(props.selectedRowsDataForBulkEdit);
      } else if (props.isPopupOpenedFromProcessTemplateTaskTrigger) {
        dispatch({
          type: SET_TASK_FORM_DATA,
          data: {
            taskFormData: {
              ...taskFormData,
              assignedToUserId:
                assignedUserType == USER_TYPE.TG
                  ? selectedUserGroup.taskGroupId
                  : selectedUserGroup.externalUserGroupId,
              assignedUserType: assignedUserType,
            },
          },
        });
      } else if (!props.isPopupOpenedFromTaskTemplate) {
        let isFromAssignedToField = false;
        if (!isSelectUserPopupOpenedFromCompletedBy) {
          isFromAssignedToField = true;
          dispatch({
            type: SET_USER_TASK_FORM_DATA,
            data: {
              userTaskFormData: {
                assignedToUserId:
                  assignedUserType == USER_TYPE.TG
                    ? selectedUserGroup.taskGroupId
                    : selectedUserGroup.externalUserGroupId,
                assignedUserType: assignedUserType,
              },
            },
          });
        }
        if (props.auditGroupId && props.auditGroupId > 0)
          props.getAssignedUserList(props.auditGroupId, isFromAssignedToField);
      } else {
        if (assignedToUserTypeList && assignedToUserTypeList.length > 0) {
          let originalAssignedToUserTypeList = assignedToUserTypeList.filter(
            (x) => !x.taskGroupId && !x.externalUserGroupId
          );
          let userGroup = null;
          if (assignedUserType == USER_TYPE.TG) {
            userGroup = taskGroupList?.find(
              (x) => x.taskGroupId === selectedUserGroup.taskGroupId
            );
            if (userGroup?.taskGroupId > 0) {
              userGroup.displayName = userGroup.taskGroupName + ` (Task Group)`;
              userGroup.value = userGroup.taskGroupId;
            }
          } else if (assignedUserType == USER_TYPE.EG) {
            userGroup = externalUserGroupList?.find(
              (x) =>
                x.externalUserGroupId === selectedUserGroup.externalUserGroupId
            );
            if (userGroup?.externalUserGroupId > 0) {
              userGroup.displayName =
                userGroup.externalUserGroupName + ` (External User Group)`;
              userGroup.value = userGroup.externalUserGroupId;
            }
          } 
          if (userGroup) originalAssignedToUserTypeList.push(userGroup);
          dispatch({
            type: FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
            assignedToUserTypeList: originalAssignedToUserTypeList,
          });
          dispatch({
            type: SET_TASK_TEMPLATE_FORM_DATA,
            data: {
              taskTemplateFormData: {
                assignedToUserTypeValue:
                  assignedUserType == USER_TYPE.TG
                    ? selectedUserGroup.taskGroupId
                    : selectedUserGroup.externalUserGroupId,
                assignedUserType: assignedUserType,
                assignedToUserId:
                  assignedUserType == USER_TYPE.TG
                    ? selectedUserGroup.taskGroupId
                    : selectedUserGroup.externalUserGroupId,
              },
            },
          });
        }
      }
      toggleSelectAssignedGroupUserPopup(dispatch, false);
    }
  }, [
    selectGroupDataGridInstance,
    isSelectUserPopupOpenedFromCompletedByBulkEdit,
    assignedUserType,
    taskFormData,
    isSelectUserPopupOpenedFromCompletedBy,
    assignedToUserTypeList,
    taskGroupList,
    externalUserGroupList,
  ]);

  return (
    <>
      <MdaePopup
        deferRendering={false}
        height={610}
        maxWidth={1000}
        id={"pnlSelectAssignedGroupUserPopup"}
        mdaeTitleRender={getSelectExternalUserGroupPopupTitle}
        visible={isSelectAssignedGroupUserPopupVisible}
        mdaeContentRender={() => {
          return (
            <div className={"select-user-group-container"}>
              <div className={"select-user-group-list-container col-xs-12"}>
                <SelectUserGroupList />
              </div>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"btnCancelSelectUserGroup"}
                  role={"secondary"}
                  onClick={() => {
                    toggleSelectAssignedGroupUserPopup(dispatch, false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <>
                  <MdaeButton
                    id={"btnContinueSelectUserGroup"}
                    onClick={() => {
                      selectUserToUserGroup();
                    }}
                    role={"primary"}
                    disabled={!setCurrentSelectedGroupRowData}
                  >
                    Continue
                  </MdaeButton>
                </>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
    </>
  );
};

const NestedUserListGrid = ({ data }) => {
  const assignedUserType = useSelector(
    (state: any) => state.userTaskListReducer.assignedUserType
  );
  return (
    <DataGrid
      dataSource={
        assignedUserType == USER_TYPE.EG
          ? data?.data?.externalUserGroupAssociationList
          : data?.data?.taskGroupAssociationList
      } // Pass nested data as the data source
      keyExpr={assignedUserType == USER_TYPE.EG ? "externalUserId" : "userId"} // Unique key for nested rows
      showBorders={true}
    >
      {assignedUserType == USER_TYPE.EG && (
        <Column dataField="externalUserName" caption="External User Name" />
      )}
      {assignedUserType == USER_TYPE.TG && (
        <Column dataField="userName" caption="User Name" />
      )}
      <Column dataField="email" caption="Email Address" />
    </DataGrid>
  );
};

const SelectUserGroupList: React.FC<ISelectUserGroupProps> = () => {
  const dispatch = useDispatch();

  const externalUserGroupListWithAssociation = useSelector(
    (state: any) =>
      state.userTaskListReducer.externalUserGroupListWithAssociation
  );
  const taskGroupListWithAssociation = useSelector(
    (state: any) => state.userTaskListReducer.taskGroupListWithAssociation
  );
  const assignedUserType = useSelector(
    (state: any) => state.userTaskListReducer.assignedUserType
  );
  const onSelectExternalUserGroupDataGridInitialized = useCallback((e) => {
    dispatch({
      type: SET_SELECT_GROUP_DATAGRID_INSTANCE,
      data: {
        selectGroupDataGridInstance: e.component,
      },
    });
  }, []);

  const onSelectExternalUserGroupDataGridSelectionChanged = useCallback((e) => {
    dispatch({
      type: SET_CURRENT_SELECTED_GROUP_ROW_DATA,
      data: {
        setCurrentSelectedGroupRowData: e,
      },
    });
  }, []);
  const selectExternalAssignedGroupUserDataGridOptions = useMemo(() => {
    return getSelectUserGroupDataGridOptions(
      assignedUserType == USER_TYPE.EG
        ? externalUserGroupListWithAssociation
        : taskGroupListWithAssociation,
      onSelectExternalUserGroupDataGridInitialized,
      onSelectExternalUserGroupDataGridSelectionChanged,
      assignedUserType
    );
  }, [
    externalUserGroupListWithAssociation,
    taskGroupListWithAssociation,
    assignedUserType,
  ]);
  return (
    <div>
      <MdaeDataGrid {...selectExternalAssignedGroupUserDataGridOptions}>
        <MasterDetail enabled={true} component={NestedUserListGrid} />
      </MdaeDataGrid>
    </div>
  );
};

const getSelectUserGroupDataGridOptions = (
  userGroupListWithAssociation,
  onSelectExternalUserDataGridInitialized,
  onSelectExternalUserDataGridSelectionChanged,
  assignedUserType
) => {
  const columns =
    assignedUserType == USER_TYPE.EG
      ? [
          {
            caption: "Name",
            dataField: "externalUserGroupName",
          },
          {
            caption: "Description",
            dataField: "description",
          },
        ]
      : [
          {
            caption: "Name",
            dataField: "taskGroupName",
          },
          {
            caption: "Description",
            dataField: "description",
          },
        ];
  const assignedGroupUserListDataGridOptions: IMdaeDataGridProps = {
    id: "grdSelectExternalUserGroupList",
    mdaeColumnChooser: { isMdaeColumnChooserVisible: false },
    headerFilter: {
      visible: true,
    },
    allowColumnResizing: true,
    allowColumnReordering: true,
    filterRow: {
      visible: true,
    },
    keyExpr:
      assignedUserType == USER_TYPE.EG ? "externalUserGroupId" : "taskGroupId",
    onInitialized: onSelectExternalUserDataGridInitialized,
    selection: { mode: "single", showCheckBoxesMode: "always" },
    pageSize: 10,
    height: "450px",
    onSelectionChanged: onSelectExternalUserDataGridSelectionChanged,
    onContentReady: () => {
      $(
        ".dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused).dx-row-lines > td, .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover.dx-row-lines > td"
      ).addClass("application-section-primary-background-color");
    },
    mdaeColumns: columns,
    dataSource: userGroupListWithAssociation,
  };
  return assignedGroupUserListDataGridOptions;
};

export default SelectAssignedGroupUser;
